export const booking = {
  overview: {
    table: {
      name: {
        label: "Auftragsnummer",
      },
      exhibition: {
        label: "Veranstaltung",
      },
      orderType: {
        label: "Auftragstyp",
        items: {
          StandBooking: "Standbuchung",
          DigitalEvent: "Digitales Event",
          Sponsoring: "Sponsoring",
          Advertisement: "Anzeige",
          Individual: "Individuell",
          fallback: "Nicht definiert",
        },
      },
      exhibitor: {
        label: "Auftraggeber",
      },
      createdOn: {
        label: "Erstellt am",
      },
      coexhibitorCount: {
        label: "Anzahl Mitaussteller",
      },
      phase: {
        label: "Status",
        items: {
          New: "Neu",
          Pending: "Ausstehend",
          Cancelled: "Storniert",
          Deferred: "Zurückgestellt",
          Internal: "Intern",
          Released: "Veröffentlicht",
          Service: "Service",
          DownPaymentInvoicing: "In Bearbeitung",
          Draft: "Entwurf",
          Waiting: "Warteliste",
          Checked: "Geprüft",
          InProgress: "In Bearbeitung",
          SentInProgress: "In Bearbeitung",
          Placed: "In Bearbeitung",
          ProposalCreated: "Vorschlag erstellt",
          ProposalSent: "Vorschlag gesendet",
          ProposalRejected: "Vorschlag abgelehnt",
          ProposalAssumed: "Vorschlag angenommen",
          Support: "Support",
          InvoiceReady: "Faktura bereit",
          Invoicing: "Fakturierung",
          InvoiceCreated: "Schlussrechnung erstellt",
          IncomingPayment: "Zahlungseingang",
          Closed: "Geschlossen",
          fallback: "Nicht definiert",
        },
      },
    },
    noData: "Wählen Sie eine Standbuchung im Dropdown-Menü aus.",
    bookingsExternal: {
      headline: "Ihre weiteren Standbuchungen",
    },
  },
  detail: {
    header: {
      title: {
        title: "Standfläche",
        orderPrefix: "Auftrag",
      },
      hall: "Halle",
      stand: "Stand",
      area: {
        title: "Standfläche",
        unit: "m²",
      },
    },
    actions: {
      addBooking: "Stand buchen",
      print: {
        title: "Drucken",
      },
      addCoExhibitor: {
        title: "Mitaussteller hinzufügen",
        description:
          "Versenden Sie eine Einladungsemail an Firmen, die an Ihrem Stand ausstellen sollen oder registrieren Sie Ihre Mitaussteller direkt.",
        emailInvite: {
          title: "Einladung versenden",
          linkText:
            "Klicken Sie auf den Button „Vorlage Mitaussteller-Einladung“, um eine Vorlage für Ihre Einladungsemail zu erhalten. Versenden Sie diese an Firmen, die an Ihrem Stand ausstellen sollen. Nach Befüllen des Formulars durch den Mitaussteller erfolgt die Zuordnung der Anmeldung zu Ihrer Standanmeldung automatisch.\nBitte prüfen Sie die Liste der angemeldeten Mitaussteller regelmäßig in der Detailansicht der Standanmeldung.",
          form: {
            emailInvite: {
              fields: {
                language:
                  "Bitte wählen Sie die gewünschte Korrespondenzsprache:",
                template:
                  "Hallo,\n\nwir nehmen als COMPANY an der TRADEFAIR-DE teil, die vom START bis END stattfindet, und laden Sie ein, uns als Mitaussteller zu begleiten.\nFalls Sie noch keinen Nutzeraccount für das Ausstellerportal der Messe Berlin haben, registrieren Sie sich bitte erst hier: REGISTERURL\nUm sich als Mitaussteller auf unserem Stand anzumelden, nutzen Sie bitte anschließend diesen Link: INVITELINK\nIhre Anmeldung wird automatisch unserer Standbuchung hinzugefügt.\nMehr Informationen zur TRADEFAIR-DE finden Sie im Übrigen auch unter TRADEFAIRURL.\n\nFreundliche Grüße,",
              },
            },
          },
          button: "Vorlage Mitaussteller-Einladung",
        },
        selfEntry: {
          title: "Selber ausfüllen",
          form: {
            buttons: {
              back: "Zurück",
              next: "Nächster Schritt",
              finish: "Mitaussteller anmelden",
            },
          },
        },
        cancel: "Abbrechen",
      },
      editCoExhibitor: {
        title: "Mitaussteller bearbeiten",
        form: {
          buttons: {
            back: "Zurück",
            next: "Nächster Schritt",
            finish: "Mitaussteller updaten",
          },
        },
        cancel: "Abbrechen",
      },
      deleteCoExhibitor: {
        title: "Mitaussteller löschen",
        content:
          "Sind Sie sicher das Sie den Mitaussteller von der Buchung entfernen möchten?",
        delete: "Löschen",
        cancel: "Abbrechen",
        error:
          "Die Frist zum Absagen von Mitausstellern ist abgelaufen. Für Fragen steht Ihnen das Messeteam gerne zur Verfügung.",
      },
      deleteDocument: {
        title: "Dokument löschen",
        content: "Sind Sie sicher das Sie das Dokument löschen möchten?",
        delete: "Löschen",
        cancel: "Abbrechen",
      },
      serviceRequests: {
        title: "Serviceanfragen",
      },
      permissions: {
        title: "Berechtigungen",
        selectBookingLabel: "Standbuchungen",
        selectBookingHelperText: "Bitte wählen Sie die Standbuchung aus.",
        selectBookingStandhall: " | Halle ",
        selectBookingStandnumber: " | Stand ",
        noData: "Keine Berechtigungen auf fremde/eigene Rechnungen vorhanden.",
        actions: {
          add: {
            title: "Nutzer hinzufügen",
            form: {
              email: "E-Mail des Nutzers",
              hasAdminPermissions:
                "Der ausgewählte Nutzer besitzt bereits die Rolle {role}, wodurch ihm automatisch auch die anderen Rollen zugewiesen sind",
              role: "Rolle",
            },
            buttons: {
              add: "Hinzufügen",
              cancel: "Abbrechen",
            },
          },
        },
        table: {
          name: {
            label: "Name",
          },
          email: {
            label: "E-Mail",
          },
          role: {
            label: "Rolle",
            items: {
              Administrator: "Standbuchung verwalten",
              BuyOnOwnAccount: "Bestellen auf separate Rechnung",
              BuyOnForeignAccount: "Bestellen auf fremde Rechnung",
              BuyOnForeignAccount1: "Bestellen auf Rechnung von {company}",
            },
          },
          emailForeignAccount: {
            label: "Hauptkontakt",
          },
        },
        cancel: "Abbrechen",
      },
      placements: {
        reject: {
          title: "Begründung der Ablehnung",
          content:
            "Bitte beschreiben Sie uns die genauen Gründe für Ihre Ablehnung in einer kurzen Nachricht, damit wir ggf. alternative Standflächen für Sie suchen können. Wir bitten um Ihr Verständnis, dass dies in der Regel etwas Zeit benötigt.",
          form: {
            message: "Begründung",
          },
          buttons: {
            reject: "Ablehnen",
            cancel: "Abbrechen",
          },
        },
      },
      editButton: "Bearbeiten",
    },
    banner: {
      title: "Ihre weiteren Schritte",
      contentAddCoExhibitor:
        "Sie können Mitaussteller selbst registrieren oder Firmen als Mitaussteller einladen.",
      buttonAddCoExhibitor: "Jetzt Mitaussteller hinzufügen",
      contentCopy:
        "Sie können die Daten aus dieser Anmeldung in einen neuen Standbuchungsentwurf übernehmen.",
      buttonCopy: "Jetzt Daten übernehmen",
      buttonDraft: "Entwurf bearbeiten",
      buttonPermission: "Berechtigungen verwalten",
    },
    exhibition: {
      exhibitionName: "Veranstaltung",
      exhibitor: "Auftraggeber",
      createdOn: "Erstellt am",
      coExhibitor: "Angemeldete Mitaussteller",
    },
    documents: {
      title: "Meine Dokumente",
      button: "Jetzt herunterladen",
    },
    placement: {
      Proposed: {
        title: "Platzierungsvorschlag",
        meta: "Wir haben folgenden Stand für Sie reserviert:",
        content: `Wenn Sie mit diesem Vorschlag einverstanden sind und den Stand verbindlich buchen möchten, bestätigen Sie dies bitte durch das Klicken auf den Button „Verbindlich annehmen“. Im Falle einer Ablehnung durch Klicken auf den Button „Ablehnen“ wird Ihre Begründung abgefragt und die Möglichkeit eines neuen Vorschlags geprüft.`,
        expiresAt: "Platzierungsvorschlag läuft ab am",
        info1: "",
        info2: "",
        info3: "",
        info4: "",
        contact1: "",
        contact2: "",
        buttons: {
          left: "Ablehnen",
          right: "Verbindlich annehmen",
        },
        futureStep: {
          title: "",
          content: "",
        },
      },
      Accept: {
        title: "Platzierungsvorschlag angenommen",
        meta: "Vielen Dank für die Bestätigung des Platzierungsvorschlages. Wir haben den folgenden Stand für Sie gebucht:",
        content:
          "Mit der nun bestätigten Platzierung können Sie Ihre Bestellungen im Webshop tätigen, sobald dieser verfügbar ist.\n Sie erhalten von uns zudem in Kürze eine Auftragsbestätigung sowie eine Anzahlungsrechnung\nper E-Mail.",
        expiresAt: "",
        info1: "Platzierung wurde am",
        info2: "von",
        info3: "angenommen",
        info4: "",
        contact1: "",
        contact2: "",
        buttons: {
          left: "",
          right: "",
        },
        futureStep: {
          title: "",
          content: "",
        },
      },
      Reject: {
        title: "Abgelehnte Platzierung",
        meta: "Wir haben folgenden Stand für Sie reserviert:",
        content: "",
        expiresAt: "",
        info1: "Platzierung wurde am",
        info2: "von",
        info3: "abgelehnt",
        info4: "",
        contact1: "",
        contact2: "",
        buttons: {
          left: "",
          right: "",
        },
        futureStep: {
          title: "Neuer Platzierungsvorschlag",
          content:
            "Sie erhalten eine Information per E-Mail, sofern wir Ihnen einen\nneuen Platzierungsvorschlag unterbreiten können.",
        },
      },
      Expired: {
        title: "Platzierungsvorschlag abgelaufen",
        meta: "Wir haben folgenden Stand für Sie reserviert:",
        content: `Wenn Sie mit diesem Vorschlag einverstanden sind und den Stand verbindlich buchen möchten, bestätigen Sie dies bitte durch das Klicken auf den Button „Verbindlich annehmen“. Im Falle einer Ablehnung durch Klicken auf den Button „Ablehnen“ wird Ihre Begründung abgefragt und die Möglichkeit eines neuen Vorschlags geprüft.`,
        expiresAt: "Platzierungsvorschlag läuft ab am",
        info1: "",
        info2: "",
        info3: "",
        info4: "",
        contact1: "Bitte wenden Sie sich an",
        contact2: "um ggf. erneut einen Platzierungsvorschlag zu erhalten.",
        buttons: {
          left: "",
          right: "",
        },
        futureStep: {
          title: "",
          content: "",
        },
      },
      download: "Platzierungsvorschlag Details (PDF)",
    },
    info: {
      companyStep: {
        title: "Angaben zur Firma",
        company: {
          title: "Angaben zur Firma",
          fields: {
            title: "Angaben zur Firma",
            language: "Korrespondenzsprache",
            exhibitor: "Name des Hauptausstellers",
            street: "Straße",
            houseNumber: "Hausnummer",
            zip: "Postleitzahl",
            city: "Stadt",
            country: "Land",
            website: "Webseite",
            email: "E-Mail (Unternehmen)",
            phone: "Telefon",
            fax: "Fax",
            exhibitorDesignName:
              "Name des Mitaussteller im Ausstellerverzeichnis",
          },
        },
      },
    },
    coExhibitors: {
      headline: "Angemeldete Mitaussteller",
      table: {
        name: {
          label: "Firmenname",
        },
        phase: {
          label: "Status",
          items: {
            Internal: "Intern",
            Draft: "Entwurf",
            New: "Neu",
            Placed: "In Bearbeitung",
            Service: "Service",
            DownPaymentInvoicing: "In Bearbeitung",
            Invoicing: "Fakturierung",
            Closed: "Geschlossen",
            Pending: "Ausstehend",
            Cancelled: "Storniert",
            Deferred: "Zurückgestellt",
            Released: "Veröffentlicht",
            Waiting: "Warteliste",
            Checked: "Geprüft",
            InProgress: "In Bearbeitung",
            SentInProgress: "In Bearbeitung",
            ProposalCreated: "Vorschlag erstellt",
            ProposalSent: "Vorschlag gesendet",
            ProposalRejected: "Vorschlag abgelehnt",
            ProposalAssumed: "Vorschlag angenommen",
            Support: "Support",
            InvoiceReady: "Faktura bereit",
            InvoiceCreated: "Schlussrechnung erstellt",
            IncomingPayment: "Zahlungseingang",
            fallback: "Nicht definiert",
          },
        },
        city: {
          label: "Stadt",
        },
        country: {
          label: "Land",
        },
        createdOn: {
          label: "Erstellt am",
        },
      },
      dataTable: {
        company: {
          title: "Restlichen Angaben zur Firma",
          items: {
            orderNumber: "Auftragsnummer",
            street: "Straße",
            zip: "Postleitzahl",
            website: "Webseite",
            phone: "Telefon",
          },
        },
      },
      noData: "Es wurden noch keine Mitaussteller hinzugefügt.",
    },
  },
}
